// // src/App.js
// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
// import Sidebar from "./components/Sidebar";
// import Dashboard from "./pages/Dashboard";
// import Billing from "./pages/Billing";
// import { auth } from "./firebase";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./App.css"; // Import custom CSS
// import Detail from "./pages/Detail";

// const App = () => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [timer, setTimer] = useState(null);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     // const dbRef = ref(database, "op4/");
//     // set(dbRef, null);

//     // Firebase auth state observer
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setIsAuthenticated(true); // User is logged in
//       } else {
//         setIsAuthenticated(false); // User is not logged in
//       }
//       setLoading(false); // Stop loading once we have the authentication status
//     });

//     // Cleanup the listener on component unmount
//     return () => unsubscribe();
//   }, []);

//   const handleLogin = async () => {
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       setIsAuthenticated(true);
//     } catch (err) {
//       setError("Invalid credentials or an error occurred.");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loader">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       {!isAuthenticated ? (
//         <div className="login-container">
//           <div className="card login-card">
//             <div className="card-body">
//               <h3
//                 className="card-title text-center mb-4"
//                 style={{ color: "#9D00FF" }}
//               >
//                 Login
//               </h3>
//               {error && <div className="alert alert-danger">{error}</div>}
//               <form>
//                 <div className="form-group">
//                   <label htmlFor="email">Email:</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     id="email"
//                     placeholder="Enter email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                 </div>
//                 <div className="form-group mt-3">
//                   <label htmlFor="password">Password:</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     id="password"
//                     placeholder="Enter password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//                 <button
//                   type="button"
//                   className="btn btn-primary mt-4 w-100"
//                   style={{ backgroundColor: "#9D00FF", borderColor: "#9D00FF" }}
//                   onClick={handleLogin}
//                 >
//                   Login
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <Router>
//           <div className="app-layout">
//             <Sidebar />
//             <div className="main-content">
//               <div className="page-content">
//                 <Routes>
//                   <Route path="/" element={<Dashboard />} />
//                   <Route path="/billing" element={<Billing />} />
//                   <Route path="/details" element={<Detail />} /> {/* Details page */}
//                 </Routes>
//               </div>
//             </div>
//           </div>
//         </Router>
//       )}
//     </div>
//   );
// };

// export default App;

import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Billing from "./pages/Billing";
import Detail from "./pages/Detail";
import { auth } from "./firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // Custom CSS

// ✅ Moved LoginPage outside App
const LoginPage = ({ email, password, error, setEmail, setPassword, handleLogin }) => {
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    handleLogin();
  };

  return (
    <div className="login-container">
      <div className="card login-card">
        <div className="card-body">
          <h3 className="card-title text-center mb-4" style={{ color: "#9D00FF" }}>
            Login
          </h3>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary mt-4 w-100"
              style={{ backgroundColor: "#9D00FF", borderColor: "#9D00FF" }}
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};


const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setIsAuthenticated(true);
      setError("");
    } catch (err) {
      setError("Invalid credentials or an error occurred.");
    }
  };

  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  if (loading) {
    return (
      <div className="loader">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <Router basename="/">
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" />
            ) : (
              <LoginPage
                email={email}
                password={password}
                error={error}
                setEmail={setEmail}
                setPassword={setPassword}
                handleLogin={handleLogin}
              />
            )
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <div className="app-layout">
                <Sidebar />
                <div className="main-content">
                  <div className="page-content">
                    <Dashboard />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <div className="app-layout">
                <Sidebar />
                <div className="main-content">
                  <div className="page-content">
                    <Billing />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/details"
          element={
            <ProtectedRoute>
              <div className="app-layout">
                <Sidebar />
                <div className="main-content">
                  <div className="page-content">
                    <Detail />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/" : "/login"} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
